import { type OfferDocumentPurpose, type OfferDocumentRef } from './offerDraft';

export type FinancingDocumentPurpose = 'PROOF_OF_FUNDS' | 'PRE_APPROVAL_LETTER';

/** The one supporting document a financing type calls for; null until financing is answered. */
export const financingDocumentPurpose = (
  financingType: string | null,
): FinancingDocumentPurpose | null => {
  switch (financingType) {
    case 'cash':
      return 'PROOF_OF_FUNDS';
    case 'conventional':
    case 'fha':
    case 'va':
    case 'other':
      return 'PRE_APPROVAL_LETTER';
    default:
      return null;
  }
};

const isFinancingDocument = (purpose: OfferDocumentPurpose): boolean =>
  purpose === 'PROOF_OF_FUNDS' || purpose === 'PRE_APPROVAL_LETTER';

/**
 * Whether a document belongs on a draft with this financing type: contract
 * documents always do, a financing document only when it is the one the
 * financing type calls for.
 */
export const isDocumentForFinancing = (
  purpose: OfferDocumentPurpose,
  financingType: string | null,
): boolean => !isFinancingDocument(purpose) || purpose === financingDocumentPurpose(financingType);

export const financingDocumentLabel = (purpose: FinancingDocumentPurpose): string =>
  purpose === 'PROOF_OF_FUNDS' ? 'Proof of funds' : 'Mortgage pre-approval';

export const documentsForFinancing = (
  documents: OfferDocumentRef[],
  financingType: string | null,
): OfferDocumentRef[] =>
  documents.filter((document) => isDocumentForFinancing(document.purpose, financingType));
